// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30h1H","colMin":"styles_colMin__PTwks"};